<template>
    <div id="app" class="app" data-server-rendered="true" v-touch:swipe.left.right="swipeHandler">
        <SectionHeader class="app__header" />

        <RouterView @openMenu="openMenu" />

        <BlockMenu
            :is-active="showMenu"
            :active-section="activeSection"
            @click="closeMenu"
        />

        <transition name="fade">
            <UiBtn
                class="app__menu-btn"
                :is-active="showMenu"
                :during="true"
                :progress="progress"
                :active-section="activeSection"
                :show-progress="showProgress && !showMenu"
                v-if="show"
                @click="openMenu"
            />
        </transition>
    </div>
</template>

<script>
import throttle from '@/utils/throttle'
import BlockMenu from '@/components/blocks/menu'
import SectionHeader from '@/components/sections/header'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

let timer;
const sections = [
    '#section0', '#section1', '#section2', '#section3', '#section4', '#section5'
];

export default {
    components: {
        BlockMenu,
        SectionHeader
    },
    data () {
        return {
            show: false,
            progress: 0,
            showMenu: false,
            showProgress: false,
            activeSection: 0,
            sectionsPosition: []
        }
    },
    methods: {
        swipeHandler (direction) {
            if (direction === 'left') {
                this.closeMenu()
            } else if (direction === 'right') {
                this.openMenu(true)
            }
        },
        openMenu (check) {
            if (check && this.showMenu) return
            this.showMenu = !this.showMenu
            this.showMenu ? disableBodyScroll() : clearAllBodyScrollLocks()
        },
        closeMenu () {
            this.showMenu = false
            clearAllBodyScrollLocks()
        },
        handleScroll () {
            clearTimeout(timer)
            this.showProgress = true
            this.activeSection = this.getActiveSection()
            this.progress = this.getSectionProgress()

            timer = setTimeout(() => {
                this.showProgress = false
            }, 1000)
        },
        getSize (selector) {
            const $el = document.querySelector(selector)
            const value = $el.getBoundingClientRect()
            value.y = value.y - window.innerHeight + 60
            return value
        },
        getSectionProgress () {
            if (!this.activeSection) return 0

            const props = this.sectionsPosition[this.activeSection ]
            return ((props.top - 8) / props.height) * -100
        },
        getActiveSection () {
            let localSectionIndex = 0
            this.sectionsPosition = sections.map(this.getSize)

            if (window.innerHeight + this.sectionsPosition[0].y > 0) return 0

            this.sectionsPosition.forEach((item, index) => {
                if (item.y > 0 && !localSectionIndex) localSectionIndex = index
            })

            if (!localSectionIndex) localSectionIndex = sections.length

            return localSectionIndex - 1
        }
    },
    mounted () {
        let throttleScroll = throttle(this.handleScroll, 50);

        this.$nextTick(() => {
            this.show = true
        })

        window.addEventListener('scroll', () => {
            throttleScroll()
            if (document.documentElement.clientWidth > 959) {
                this.$root.$emit('transformElement')
            }
        }, {passive: true})
    }
}
</script>

<style lang="stylus" scoped>
    .app {
        padding-bottom: 5rem
        position relative

        &__header {
            width 100%
            z-index 1
            left 0
            right 0
            position absolute
        }

        &__menu-btn.ui-btn {
            position fixed
            bottom 3.3rem
            left 1rem
            z-index 1000

            +layout-md-and-up() {
                left auto
                right calc(61.7% + 24rem)
                bottom 3.8rem
            }

            @media (min-width: 1360px) {
                left auto
                right calc(50% + 42.3rem)
            }

            @media (min-width: 1581px) {
                right auto
                left 17.3%
            }
        }
    }

    .fade-enter-active {
        transition opacity 0.5s ease, transform 12s cubic-bezier(0.25, 0.1, 0.18, 1.6)
        transition-delay .6s
    }

    .fade-enter {
        opacity 0
        transform scale(0)
    }
</style>
